export default "__VITE_ASSET__Ruc$UGRF__"